import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NavItem = ({ to, icon: IconComponent, label, expanded, onClick, isImage = false }) => {
  const location = useLocation();

  const isActive = to === '/beagle-chat'
    ? location.pathname === '/beagle-chat' || location.pathname === '/beagle-chat/'
    : location.pathname.startsWith(to);

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      className={`
        relative flex items-center px-4 py-3 mx-2 rounded-lg
        transition-all duration-200 no-underline group
        ${isActive
          ? 'bg-brand-500/15 text-white'
          : 'text-slate-400 hover:text-white hover:bg-white/5'
        }
      `}
      title={!expanded ? label : undefined}
    >
      {/* Active indicator */}
      {isActive && (
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-6 bg-brand-500 rounded-r-full" />
      )}

      {/* Icon */}
      <span className="flex items-center justify-center w-5 h-5 shrink-0">
        {isImage ? (
          <img
            src={IconComponent}
            alt={label}
            className={`w-5 h-5 ${isActive ? 'brightness-0 invert' : 'opacity-60 group-hover:opacity-100'}`}
          />
        ) : (
          <IconComponent size={20} />
        )}
      </span>

      {/* Label */}
      {expanded && (
        <span className="ml-3 text-sm font-medium whitespace-nowrap overflow-hidden transition-opacity duration-200">
          {label}
        </span>
      )}

      {/* Tooltip when collapsed */}
      {!expanded && (
        <div className="absolute left-full ml-2 px-2 py-1 bg-slate-800 text-white text-xs rounded-md
                        opacity-0 invisible group-hover:opacity-100 group-hover:visible
                        transition-all duration-200 whitespace-nowrap z-50 pointer-events-none">
          {label}
        </div>
      )}
    </Link>
  );
};

export default NavItem;
